<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <InputText :class="[{ 'p-error' : error }]" v-on="listeners" :value="value" :id="uuid" :disabled="disable" v-mask="getMask(mask)" v-if="mask" />
        <InputText :class="[{ 'p-error' : error }]" v-on="listeners" :value="value" :id="uuid" :disabled="disable" v-else />
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";
    import {mask} from 'vue-the-mask';
    import MaskUtil from "@/utils/MaskUtil";

    export default {
        name: "CoffInputText",

        directives:{mask},

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
            mask: {default: null},
        },

        data(){
            return {
                uuid: Utils.uuid(),
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    InputText: event => this.$emit('InputText', event.target.value)
                };
            },
        },

        methods: {
            getMask: MaskUtil.mask,
        }
    }
</script>

<style scoped>

</style>
